import { MetadataContent } from '@jutro/legacy/uiconfig';
import _ from 'lodash';
import React from 'react';
import metadata from './WniBaseModal.metadata.json5';

const defaultSize = 'md';

function WniBaseModal(props) {
    const { component, title, id, updateShowBaseModal, updateModalResult } = props;

    const renderComponent = (modalProps) => {
        const FieldComponent = _.get(modalProps, 'type');
        if (!FieldComponent) {
            return null;
        }
        const componentProps = _.get(modalProps, 'props', {}) 
        return <FieldComponent id={id} {...componentProps} onResolve={updateModalResult} onReject={() => updateShowBaseModal(false)} />
    };

    const modalSize = component ? _.get(props, 'size') : _.get(props, 'props.size') || defaultSize; 

    const overrides = {
        baseModal: {
            visible: !component,
            className: `${modalSize} wni__ModalNext__modal`,
            content: renderComponent(props)
        },

        // not recommended for use anymore
        abandonedBaseModal: {
            className: `${modalSize} wni__ModalNext__modal`,
            visible: !!component
        },
        abandonedBaseModalHeader: {
            ...props,
        },
        abandonedBaseModalHeaderTitle: {
            content: title
        },
        abandonedBaseModalHeaderClose: {
            onClick: () => updateShowBaseModal(false)
        },
        abandonedBaseModalBody: {
            content: renderComponent(component),
        }
    };


    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrides}
        />
    );
}

export default WniBaseModal;
